<template>
	<!-- 不同类型玩法选号  -->
	<div class="quick_gametype_box quick_gametype_box_tx">
		<div v-if="navid == 125">
			<div class="box_h flex_align_center">
				<!-- 标题 -->
				<div class="qu_gametype_title box_s">
					<p>{{ listObj1.digit }}</p>
				</div>
				<!-- 号码列表 -->
				<div class="qu_gametype_numbox box_h box_flex">
					<div
						:class="['box_s', item.state ? 'change_this_style big_icon' : '', 'dice_itm_num2']"
						v-for="(item, index) in listObj1.num"
						:key="index"
						@click="ListOne"
						:data-index="index"
					>
						<div
							:data-index="index"
							:class="[
								'icon',
								item.value == '11'
									? 'two_img11'
									: item.value == '22'
									? 'two_img22'
									: item.value == '33'
									? 'two_img33'
									: item.value == '44'
									? 'two_img44'
									: item.value == '55'
									? 'two_img55'
									: 'two_img66',
							]"
						></div>
					</div>
				</div>
				<!-- 功能按钮 -->
				<div class="box_h qu_gamebtn_box">
					<div
						:class="[index == btnCurrent ? '' : '']"
						v-for="(items, index) in gameBtn"
						:key="index"
						@click="ListAllOne"
						:data-name="items"
					>
						{{ items }}
					</div>
				</div>
			</div>
			<div class="box_h flex_align_center">
				<!-- 标题 -->
				<div class="qu_gametype_title box_s">
					<p>{{ listObj2.digit }}</p>
				</div>
				<!-- 号码列表 -->
				<div class="qu_gametype_numbox box_h box_flex">
					<div
						:class="['box_s', item.state ? 'change_this_style big_icon' : '', 'two_num1']"
						v-for="(item, index) in listObj2.num"
						:key="index"
						@click="ListTwo"
						:data-index="index"
					>
						<div
							:class="[
								'icon',
								item.value == '1'
									? 'two_img1'
									: item.value == '2'
									? 'two_img2'
									: item.value == '3'
									? 'two_img3'
									: item.value == '4'
									? 'two_img4'
									: item.value == '5'
									? 'two_img5'
									: 'two_img6',
							]"
						></div>
					</div>
				</div>
				<!-- 功能按钮 -->
				<div class="box_h qu_gamebtn_box">
					<a
						:class="[index == btnCurrent ? '' : '']"
						v-for="(items, index) in gameBtn"
						:key="index"
						@click="ListAllTwo"
						:data-name="items"
						>{{ items }}</a
					>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="box_h flex_align_center">
				<!-- 标题 -->
				<div class="qu_gametype_title box_s">
					<p>{{ listObj1.digit }}</p>
				</div>
				<!-- 号码列表 -->
				<div class="qu_gametype_numbox box_h box_flex">
					<div
						:class="['box_s', item.state ? 'change_this_style big_icon' : '']"
						v-for="(item, index) in listObj1.num"
						:key="index"
						@click="ListOne"
						:data-index="index"
					>
						{{ item.value }}
					</div>
				</div>
				<!-- 功能按钮 -->
				<div class="box_h qu_gamebtn_box">
					<div
						:class="[index == btnCurrent ? '' : '']"
						v-for="(items, index) in gameBtn"
						:key="index"
						@click="ListAllOne"
						:data-name="items"
					>
						{{ items }}
					</div>
				</div>
			</div>
			<div class="box_h flex_align_center">
				<!-- 标题 -->
				<div class="qu_gametype_title box_s">
					<p>{{ listObj2.digit }}</p>
				</div>
				<!-- 号码列表 -->
				<div class="qu_gametype_numbox box_h box_flex">
					<div
						:class="['box_s', item.state ? 'change_this_style big_icon' : '']"
						v-for="(item, index) in listObj2.num"
						:key="index"
						@click="ListTwo"
						:data-index="index"
					>
						{{ item.value }}
					</div>
				</div>
				<!-- 功能按钮 -->
				<div class="box_h qu_gamebtn_box">
					<a
						:class="[index == btnCurrent ? '' : '']"
						v-for="(items, index) in gameBtn"
						:key="index"
						@click="ListAllTwo"
						:data-name="items"
						>{{ items }}</a
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		gameAry: {
			type: Array,
			required: true,
		},
		navid: {
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			gameBtn: ["全", "大", "小", "奇", "偶", "清"], //按钮选项
			btnCurrent: -1, //点击状态
			selectAry: [], //选中的值
			state: true,
			listObj1: {}, //渲染的对象
			listObj2: {}, //渲染的对象
			listAry1: [], //选择内容
			listAry2: [], //选择内容
		};
	},
	methods: {
		// 选择单个号码
		ListOne(e) {
			let index = e.target.dataset.index;
			let id = 0;
			if (this.listObj1.num[index].state) {
				this.listObj1.num[index].state = false;
			} else {
				this.listObj1.num[index].state = true;
			}
			this.ListOneLimit(index);
		},
		ListTwo(e) {
			let index = e.target.dataset.index;
			let id = 0;
			if (this.listObj2.num[index].state) {
				this.listObj2.num[index].state = false;
			} else {
				this.listObj2.num[index].state = true;
			}
			this.ListTwoLimit(index);
		},
		// 判断
		ListOneLimit(index) {
			if (this.listObj2.num[index].state) {
				this.listObj2.num[index].state = false;
			}
			this.putAry();
		},
		ListTwoLimit(index) {
			if (this.listObj1.num[index].state) {
				this.listObj1.num[index].state = false;
			}
			this.putAry();
		},

		// 点击按钮
		ListAllOne(e) {
			let that = this;
			let name = e.target.dataset.name;
			that.listObj1.num.forEach(function (item, index) {
				item.state = false;
				if (name == "全") {
					item.state = true;
				} else if (name == "清") {
					item.state = false;
				} else if (name == "大") {
					if (index > 2) {
						item.state = true;
					}
				} else if (name == "小") {
					if (index < 3) {
						item.state = true;
					}
				} else if (name == "奇") {
					if (index % 2 == 0) {
						item.state = true;
					}
				} else if (name == "偶") {
					if (index % 2 != 0) {
						item.state = true;
					}
				}
			});
			this.ListAllOneLimit();
		},
		ListAllTwo(e) {
			let that = this;
			let name = e.target.dataset.name;
			that.listObj2.num.forEach(function (item, index) {
				item.state = false;
				if (name == "全") {
					item.state = true;
				} else if (name == "清") {
					item.state = false;
				} else if (name == "大") {
					if (index > 2) {
						item.state = true;
					}
				} else if (name == "小") {
					if (index < 3) {
						item.state = true;
					}
				} else if (name == "奇") {
					if (index % 2 == 0) {
						item.state = true;
					}
				} else if (name == "偶") {
					if (index % 2 != 0) {
						item.state = true;
					}
				}
			});
			this.ListAllTwoLimit();
		},
		// 数组判断
		ListAllOneLimit() {
			let indexAry = [];
			this.listObj1.num.forEach(function (item, index) {
				if (item.state == true) {
					indexAry.push(index);
				}
			});
			for (let i = 0; i < indexAry.length; i++) {
				let num = indexAry[i];
				this.listObj2.num[num].state = false;
			}
			this.putAry();
		},
		ListAllTwoLimit() {
			let indexAry = [];
			this.listObj2.num.forEach(function (item, index) {
				if (item.state == true) {
					indexAry.push(index);
				}
			});
			for (let i = 0; i < indexAry.length; i++) {
				let num = indexAry[i];
				this.listObj1.num[num].state = false;
			}
			this.putAry();
		},
		// 加入数组
		putAry() {
			let ary = [];
			let listAry1 = [];
			this.listObj1.num.forEach(function (item, index) {
				if (item.state == true) {
					listAry1.push(item.name);
				}
			});
			this.listAry1 = listAry1;
			let listAry2 = [];
			this.listObj2.num.forEach(function (item, index) {
				if (item.state == true) {
					listAry2.push(item.name);
				}
			});
			this.listAry2 = listAry2;
			let num = parseInt(listAry1.length) * parseInt(listAry2.length);
			this.$emit("setbet", num);
			ary.push(listAry1.join(""));
			ary.push(listAry2.join(""));
			this.selectAry = ary;
			this.$emit("getdata", this.selectAry);
		},
	},
	created() {
		this.listObj1 = this.gameAry[0];
		this.listObj2 = this.gameAry[1];
	},
};
</script>

<style>
.quick_gametype_box {
	width: 100%;
}
.quick_gametype_box_tx .box_h {
	justify-content: normal;
}
.quick_gametype_box > div {
	align-items: center;
}

.qu_gametype_title {
	height: 59px;
	text-align: center;
	font-size: 12px;
	color: #8e8e8e;
	line-height: 22px;
	justify-content: center;
	flex-shrink: 0;
}

.qu_gametype_title > p {
	padding: 0 10px;
	color: #666666;
	font-size: 16px;
	font-weight: bold;
	line-height: 40px;
	border-radius: 5px;
}

/* 号码列表 */
.quick_gametype_box > div > div > .qu_gametype_numbox {
	flex-wrap: wrap;
	flex: unset;
	width: 560px;
	text-align: center;
	margin-left: 0;
}

.qu_gametype_numbox > .change_this_style {
	background-color: #d86556;
}

.quick_gametype_box .qu_gametype_numbox > div.two_num1 {
	width: 70px;
	height: 50px;
	background: #ffffff;
	box-shadow: 0px 0px 7px 0 rgba(0, 0, 0, 0.15);
	border-radius: 8px;
}

.quick_gametype_box .qu_gametype_numbox > div.two_num1 .icon {
	width: 100%;
	height: 100%;
	background: no-repeat center / auto 32px;
	pointer-events: none;
}

.quick_gametype_box .qu_gametype_numbox > div.two_num1:hover,
.quick_gametype_box .qu_gametype_numbox > div.two_num1.change_this_style {
	background: #1e8edd;
}

.quick_gametype_box .qu_gametype_numbox > div.dice_itm_num2 {
	align-items: center;
	justify-content: center;
	font-weight: normal;
	font-style: normal;
	border-radius: 5px;
	width: 70px;
	height: 50px;
	cursor: pointer;
	font-size: 14px;
	background: #ffffff;
	box-shadow: 0px 0px 7px 0 rgba(0, 0, 0, 0.15);
	border-radius: 8px;
	padding: 10px 5px;
}

.quick_gametype_box .qu_gametype_numbox > div.dice_itm_num2 .icon {
	width: 100%;
	height: 100%;
	background-size: 100% 100%;
}

.quick_gametype_box .qu_gametype_numbox .dice_itm_num2:hover,
.quick_gametype_box .qu_gametype_numbox .dice_itm_num2.change_this_style {
	background: #1e8edd;
}

/* 功能按钮 */
.qu_gamebtn_box {
	width: 206px;
	height: 36px;
	justify-content: space-around;
	justify-items: center;
	align-items: center;
	font-size: 0;
	border-radius: 18px;
	overflow: hidden;
	padding: 0 5px;
}

.qu_gamebtn_box > div,
.qu_gamebtn_box > a {
	display: inline-block;
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16.5px;
	color: #888;
	/* 	font-weight: 600; */
	font-weight: 400;
	cursor: pointer;
}

.qu_gamebtn_box > div:hover,
.qu_gamebtn_box > a:hover {
	border: none;
	color: #fff !important;
	background: #1e8edd;
}

.two_img1 {
	background-image: url(../../static/img/ks/ks1.webp) !important;
}

.two_img2 {
	background-image: url(../../static/img/ks/ks2.webp) !important;
}

.two_img3 {
	background-image: url(../../static/img/ks/ks3.webp) !important;
}

.two_img4 {
	background-image: url(../../static/img/ks/ks4.webp) !important;
}

.two_img5 {
	background-image: url(../../static/img/ks/ks5.webp) !important;
}

.two_img6 {
	background-image: url(../../static/img/ks/ks6.webp) !important;
}

.two_img11 {
	background-image: url(../../static/img/icon/touzi_2_1.webp) !important;
}

.two_img22 {
	background-image: url(../../static/img/icon/touzi_2_2.webp) !important;
}

.two_img33 {
	background-image: url(../../static/img/icon/touzi_2_3.webp) !important;
}

.two_img44 {
	background-image: url(../../static/img/icon/touzi_2_4.webp) !important;
}

.two_img55 {
	background-image: url(../../static/img/icon/touzi_2_5.webp) !important;
}

.two_img66 {
	background-image: url(../../static/img/icon/touzi_2_6.webp) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/game_types.vue